import TimeZone from 'models/TimeZone';
import Base from 'models/Base';
import { toEntityList } from 'models/BaseList';

import {
  TIME_ZONE_ASYNC_START,
  TIME_ZONE_ASYNC_FAIL,
  TIME_ZONE_ASYNC_SUCCESS,
  TIME_ZONE_LIST_ASYNC_SUCCESS,
} from 'actions/timeZone';

const initialState = new Base({
  loading: false,
  errorMessage: '',
  data: new TimeZone(),
  list: toEntityList([], TimeZone),
});

const actionsMap = {
  [TIME_ZONE_ASYNC_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: '',
    });
  },
  [TIME_ZONE_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new TimeZone(action.data),
    });
  },
  [TIME_ZONE_LIST_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      list: toEntityList(action.data, TimeZone),
    });
  },
  [TIME_ZONE_ASYNC_FAIL]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.errorMessage,
    });
  },
};

export default function timeZone(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
